export default __webpack_public_path__ + "static/media/3A_360_2.0a780a97.jpg";